import { useTranslation } from "react-i18next";
import genericTail from "../../assets/images/generic-tail.png";
import { TabTitle } from "../../utils/GeneralFunctions";
import { Typography, Grid } from "@mui/material";
import { useAuth } from "../../providers/Auth";

import {
  PageBox,
  MainLeftContent,
  MainRightContent,
  HomeHeader,
  HomeList,
  HomeListSubheader,
  HomeListItem
} from "./Home.style";

const CreateNewUser = () => {
  const auth = useAuth();
  const { t } = useTranslation();
  
  TabTitle(t("main.header.page.title"));

  if (auth) {
    auth.refreshSession();
  }

  return (
    <>
      <PageBox>
        <Grid container sx={{ pt: 0 }}>
          {/* LeftSide menu item */}
          <MainLeftContent>
            <div className="logo-wrapper">
              <img src={genericTail} alt="Tail" />
            </div>
          </MainLeftContent>
          {/* Rightside menu item */}
          <MainRightContent>
            <HomeHeader>{t("main.header.page.title")}</HomeHeader>
            <Typography
              component="p"
              variant="lead"
              sx={{ fontSize: "1.0em", marginBottom: "1.2rem" }}
            >
              {t("main.header.page.description")}
            </Typography>
            <Typography
              component="p"
              variant="lead"
              sx={{ fontSize: "1.2em", marginBottom: "1.2rem" }}
            >
              {t("home.welcome.text", {
                name: auth?.user?.givenName,
                company: auth?.user?.company
              })}
            </Typography>
            <HomeList sx={{ fontSize: "1.0em", marginBottom: "2rem" }}>
              <HomeListSubheader>{t("home.summary.header")}</HomeListSubheader>
              <HomeListItem sx={{ display: "list-item" }}>
                {t("home.summary.name", { name: auth?.user?.givenName })}
              </HomeListItem>
              <HomeListItem sx={{ display: "list-item" }}>
                {t("home.summary.company", { company: auth?.user?.company })}
              </HomeListItem>
              <HomeListItem sx={{ display: "list-item" }}>
                {t("home.summary.username", { username: auth?.user?.username })}
              </HomeListItem>
              <HomeListItem sx={{ display: "list-item" }}>
                {t("home.summary.email", { email: auth?.user?.email })}
              </HomeListItem>
            </HomeList>
          </MainRightContent>
        </Grid>
      </PageBox>
    </>
  );
};
export default CreateNewUser;
